import { ITransaction } from "../../types";

interface TransactionDetailsModalProps {
  transaction: ITransaction;
  onClose: () => void;
}

const TransactionDetailsModal = ({
  transaction,
  onClose,
}: TransactionDetailsModalProps) => {
  const fromUser = transaction.fromUser;
  const toUser = transaction.toUser;

  return (
    <div className="fixed p-2 inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Transaction Details</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            &times;
          </button>
        </div>

        <div className="space-y-4">
          <div className="flex items-center justify-between space-x-4">
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">From</h3>
              <p>
                {fromUser?.firstName} {fromUser?.lastName}
              </p>
            </div>
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Email</h3>
              <p>{fromUser?.email}</p>
            </div>
          </div>

          <div className="flex items-center justify-between space-x-4">
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">To</h3>
              <p>
                {toUser?.firstName} {toUser?.lastName}
              </p>
            </div>
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Email</h3>
              <p>{toUser?.email}</p>
            </div>
          </div>

          <div className="flex items-center justify-between space-x-4">
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Amount</h3>
              <p>₦{transaction.amount}</p>
            </div>
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Type</h3>
              <p className="capitalize">{transaction.transactionType}</p>
            </div>
          </div>

          <div className="flex items-center justify-between space-x-4">
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Status</h3>
              <p
                className={`capitalize ${
                  transaction.transactionStatus === "completed"
                    ? "text-emerald-500"
                    : transaction.transactionStatus === "pending"
                    ? "text-amber-500"
                    : "text-rose-500"
                }`}
              >
                {transaction.transactionStatus}
              </p>
            </div>
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Reference</h3>
              <p>{transaction.reference}</p>
            </div>
          </div>

          <div className="flex items-center justify-between space-x-4">
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Created At</h3>
              <p>{new Date(transaction.createdAt).toLocaleDateString()}</p>
            </div>
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Updated At</h3>
              <p>{new Date(transaction.updatedAt).toLocaleDateString()}</p>
            </div>
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-rose-500 text-rose-500 rounded-md"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TransactionDetailsModal;
